import { z } from "zod";

export const qiviaEmailSchema = z
  .email()
  .refine((email) => email.toLowerCase().endsWith("@qivia.fr"), {
    message: "must be a @qivia.fr email address",
  });
